// extracted by mini-css-extract-plugin
export var quillEditor = "_k4-1";
export var variable = "_k4-0";